export const CATEGORY_GROUPS = [
  {
    group: 'General Traffic',
    key: 'generalTraffic',
    categories: [
      { description: 'GT1', streetFamily: null, displaySequence: 1 },
      { description: 'GT2', streetFamily: null, displaySequence: 2 },
      { description: 'GT3', streetFamily: null, displaySequence: 3 },
      { description: 'GT4', streetFamily: null, displaySequence: 4 },
      { description: 'GT5', streetFamily: null, displaySequence: 5 },
      { description: 'GT6', streetFamily: null, displaySequence: 6 },
      { description: 'GT7', streetFamily: null, displaySequence: 7 },
      { description: 'GT8', streetFamily: null, displaySequence: 8 },
    ],
  },
  {
    group: 'Freight',
    key: 'freight',
    categories: [
      { description: 'F1', streetFamily: null, displaySequence: 1 },
      { description: 'F2', streetFamily: null, displaySequence: 2 },
      { description: 'F3', streetFamily: null, displaySequence: 3 },
      { description: 'F4', streetFamily: null, displaySequence: 4 },
      { description: 'F5', streetFamily: null, displaySequence: 5 },
      { description: 'F6', streetFamily: null, displaySequence: 6 },
      { description: 'F7', streetFamily: null, displaySequence: 7 },
      { description: 'F8', streetFamily: null, displaySequence: 8 },
    ],
  },
  {
    group: 'Street Category',
    key: 'streetCategory',
    categories: [
      { description: 'Transit Corridors', streetFamily: 'Urban', displaySequence: 1 },
      { description: 'Urban Connectors', streetFamily: 'Urban', displaySequence: 2 },
      { description: 'City Hubs', streetFamily: 'Urban', displaySequence: 3 },
      { description: 'Activity Streets', streetFamily: 'Urban', displaySequence: 4 },
      { description: 'Main Streets', streetFamily: 'Urban', displaySequence: 5 },
      { description: 'Local Streets', streetFamily: 'Urban', displaySequence: 6 },
      { description: 'Civic Spaces', streetFamily: 'Urban', displaySequence: 7 },
      { description: 'Interregional Connectors', streetFamily: 'Rural', displaySequence: 8 },
      { description: 'Stopping Places', streetFamily: 'Rural', displaySequence: 9 },
      { description: 'Rural Connectors', streetFamily: 'Rural', displaySequence: 10 },
      { description: 'Peri-urban Roads', streetFamily: 'Rural', displaySequence: 11 },
      { description: 'Rural Roads', streetFamily: 'Rural', displaySequence: 12 },
    ],
  },
];
